import React from 'react';

import {SingleValueFilter} from 'search/SearchConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';
import pick from 'util/pick';
import {
  WORKFLOW_FILTER_ANY,
  WORKFLOW_STATUS_DISPLAY_NAMES,
  WORKFLOW_STATUSES,
} from 'workflows/WorkflowConstants';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface WorkflowStatusFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onRemove?: () => void;
}

export default function WorkflowStatusFilterForm(props: WorkflowStatusFilterFormProps): JSX.Element {
  const optionDatas: Array<OptionData> = [
    ...[{name: 'Any', value: WORKFLOW_FILTER_ANY}],
    ...WORKFLOW_STATUSES.map((status: string) => ({
      name: WORKFLOW_STATUS_DISPLAY_NAMES[status],
      value: status,
    })),
  ];

  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      dropdownToggleText={prefixedToggleText('Status', optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={false}
      onChangeValue={(value: string) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}
